import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Card, CardContent, CardActions, Grid, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Alert, IconButton, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const formatCurrency = (v) => `R$ ${parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;

const ListsPage = () => {
    const [lists, setLists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [form, setForm] = useState({ name: '', description: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const fetchLists = () => {
        api.get('/lists').then(r => setLists(r.data.data || [])).finally(() => setLoading(false));
    };

    useEffect(() => { fetchLists(); }, []);

    const handleCreate = async () => {
        if (!form.name.trim()) { setError('Nome da lista é obrigatório'); return; }
        try {
            const res = await api.post('/lists', form);
            setOpenDialog(false);
            setForm({ name: '', description: '' });
            navigate(`/listas/${res.data.data._id}`);
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao criar lista');
        }
    };

    const handleDelete = async (id, e) => {
        e.stopPropagation();
        if (!window.confirm('Deseja excluir esta lista?')) return;
        await api.delete(`/lists/${id}`);
        fetchLists();
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box>
                    <Typography variant="h4" fontWeight={700}>Listas de Compras</Typography>
                    <Typography color="text.secondary">Crie listas com múltiplos itens e exporte relatórios</Typography>
                </Box>
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenDialog(true)}>Nova Lista</Button>
            </Box>

            {!loading && lists.length === 0 && (
                <Card sx={{ textAlign: 'center', py: 6 }}>
                    <ShoppingCartIcon sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
                    <Typography variant="h6" color="text.secondary" mb={2}>Nenhuma lista criada</Typography>
                    <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenDialog(true)}>Criar primeira lista</Button>
                </Card>
            )}

            <Grid container sx={{ width: '100%' }} spacing={2}>
                {lists.map(list => (
                    <Grid item xs={12} sm={6} md={3} key={list._id} sx={{ minWidth: 250 }}>
                        <Card sx={{ cursor: 'pointer', transition: 'all 0.2s', '&:hover': { transform: 'translateY(-2px)', boxShadow: 4 } }} onClick={() => navigate(`/listas/${list._id}`)}>
                            <CardContent>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography variant="h6" fontWeight={600} noWrap sx={{ flex: 1, mr: 1 }}>{list.name}</Typography>
                                    {/*<Chip label={list.status === 'finalized' ? 'Finalizada' : 'Rascunho'} size="small" color={list.status === 'finalized' ? 'success' : 'default'} />*/}
                                    <Tooltip title="Excluir lista">
                                        <IconButton size="small" color="error" onClick={(e) => handleDelete(list._id, e)}><DeleteIcon fontSize="small" /></IconButton>
                                    </Tooltip>
                                </Box>
                                <Typography variant="body2" color="text.secondary" mb={1} noWrap>{list?.description || ' - '}</Typography>
                                <Typography variant="body2" color="text.secondary">{list.items?.length || 0} item(s)</Typography>
                            </CardContent>
                            <CardActions sx={{ justifyContent: 'flex-end', pt: 0 }}>
                                <Typography variant="h6" color="primary" fontWeight={700} mt={1}>{formatCurrency(list.totalEstimated)}</Typography>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Nova Lista de Compras</DialogTitle>
                <DialogContent sx={{ pt: 1 }}>
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    <TextField label="Nome da lista" value={form.name} onChange={e => { setForm(f => ({ ...f, name: e.target.value })); setError(''); }} fullWidth sx={{ mt: 1, mb: 2 }} placeholder="Ex: Compras mensais - TI" />
                    <TextField label="Descrição (opcional)" value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} fullWidth multiline rows={2} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleCreate}>Criar Lista</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ListsPage;
